// extracted by mini-css-extract-plugin
export default {"EULA":"EULA_EULA__7Qb8i","logo":"EULA_logo__HeZWY"};